// ── askQueue — one ask per mark ──────────────────────────────────────────────
// 2026-10-15. After the first mark three sheets can now queue on one event:
// InstallAsk (3s), PushAfterFirstMark (5.5s) and SaveListAsk (6s). Each is right
// alone; together they are a wall. Every mark gets ONE ask: the first sheet whose
// timer fires claims it, the others stand down WITHOUT spending their once-only
// guard, so they take the next mark instead. Order follows the delays: install,
// then push, then save. Pure, no React, so each sheet calls it at the moment it
// would open.
let claimed = 0
let lastMark = 0
let lastEvent = null

// One id per mark EVENT, however many sheets note it. Three listeners each calling
// Date.now() could land on different milliseconds, and then only the last caller's
// id matched lastMark — the others' claims were silently refused (found on the dev
// walk, 2026-10-18: the save ask never opened on the third mark).
export function noteMark(e) {
  if (e?.detail?._replay) return 0
  if (e && e === lastEvent) return lastMark
  lastEvent = e || null
  lastMark = Math.max(Date.now(), lastMark + 1)
  return lastMark
}

// true for the first caller per mark; false for everyone else on that mark. And one
// ask per SESSION (Phase 1, 2026-10-18): a session that has already asked anything
// asks nothing more; the losers keep their once-guards for a later session.
const SESSION_KEY = 'nextep_ask_session'
const sessionAsked = () => { try { return sessionStorage.getItem(SESSION_KEY) === '1' } catch { return false } }
const markSession = () => { try { sessionStorage.setItem(SESSION_KEY, '1') } catch {} }
export function claimAsk(markId) {
  if (!markId || markId !== lastMark) return false
  if (claimed === markId) return false
  if (sessionAsked()) return false
  claimed = markId
  markSession()
  return true
}
export function newSessionForTests() { try { sessionStorage.removeItem(SESSION_KEY) } catch {} }

export function _resetForTests() { claimed = 0; lastMark = 0; lastEvent = null; newSessionForTests() }
